import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

/** Same project as google-services.json (mylifesaver-61cb8). */
export const firebaseConfig = {
  apiKey: "AIzaSyAdgZsVrmHNml6pgj6HU3pVPpsQObVHggk",
  authDomain: "mylifesaver-61cb8.firebaseapp.com",
  projectId: "mylifesaver-61cb8",
  storageBucket: "mylifesaver-61cb8.firebasestorage.app",
  messagingSenderId: "607420328953",
  appId: "1:607420328953:android:711658c93d53dc4d46eb28",
};

const m_app = initializeApp(firebaseConfig);

const app = firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

const m_db = getFirestore(m_app);
const realDb = getDatabase(m_app);

export { db, firebase, realDb, m_db, m_app };
